import { watch } from "vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useNgSession } from "@sazka/ng/ng-session";
import { logException } from "@sazka/utils/logger/use-app-logger";
import { getSettingValue } from "@sazka/utils/settings-api";
import { BiRealtimeHttpMetods } from "@/shared/http-clients/bi-realtime/bi-realtime-http-methods";

const { isLoggedIn } = useNgSession();
const BONUS_ACTIVATED_TEXT = "Bonus aktivován";

interface HTMLElementExtended extends HTMLElement {
    confirmButton: () => void;
}

const setupBonusConfirmationCtas = async (buttons: HTMLElementExtended[]) => {
    let playerBonusesIds: number[] = [];
    let isPlayerRestrictedOnBonuses = false;
    let bonusRestrictedText = "Nelze aktivovat";

    try {
        const playersBonusesInfo = await BiRealtimeHttpMetods.getPlayersBonusesInfo();
        playerBonusesIds = playersBonusesInfo.bonuses;
        isPlayerRestrictedOnBonuses = playersBonusesInfo.isRestricted;

        if (isPlayerRestrictedOnBonuses) {
            bonusRestrictedText = await getSettingValue("BonusRestrictedButtonText");
        }
    } catch (ex) {
        logException("load-player-bonuses", ex);
    }

    for (const button of buttons) {
        const bonusId = parseInt(button.getAttribute("data-confirm-bonus-id"));
        if (!bonusId) return;

        if (isPlayerRestrictedOnBonuses) {
            button.innerHTML = bonusRestrictedText;
            return;
        }

        if (playerBonusesIds.some((b) => b == bonusId)) {
            button.innerHTML = BONUS_ACTIVATED_TEXT;
            return;
        }

        button.removeAttribute("disabled");

        button.confirmButton = async () => {
            Loader.show();
            try {
                await BiRealtimeHttpMetods.confirmPlayerBonus(bonusId);
                button.setAttribute("disabled", "true");
                button.innerHTML = BONUS_ACTIVATED_TEXT;
            } catch (ex) {
                logException("confirm-player-bonus", ex);
            } finally {
                Loader.hide();
            }
        };

        button.addEventListener("click", button.confirmButton);
    }
};

document.ready(async () => {
    const buttons = document.querySelectorAll<HTMLElementExtended>("button[data-confirm-bonus-id]");
    if (!buttons.length) return;

    await ngFrameworkLoaded();

    watch(
        isLoggedIn,
        async (newIsLoggedIn) => {
            if (newIsLoggedIn) {
                await setupBonusConfirmationCtas([...buttons]);
            } else {
                buttons.forEach((b) => {
                    b.setAttribute("disabled", "true");
                    b.innerHTML = b.getAttribute("data-text");

                    if (b.confirmButton) {
                        b.removeEventListener("click", b.confirmButton);
                        b.confirmButton = null;
                    }
                });
            }
        },
        { immediate: true }
    );
});
